import React from 'react'
import { Link as RouterLink } from 'react-router-dom'

export interface LinkProps {
  to: string
  className?: string
  children: React.ReactNode
}

export const Link: React.FC<LinkProps> = ({ to, className, children }) => {
  return (
    <RouterLink to={to} className={className}>
      {children}
    </RouterLink>
  )
}
